import React from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../Store/reducers/Common";

const Modal = ({ onClose, children, classList, style, isclose = true, tabed = false, classExtra = 'popup-body',containerClass="" }) => {
	const dispatch = useDispatch();
	return (
		<div className={`${(classList !== "") ? "popup-main" : "popup-notify popup-outer"}`}>
			<div className={`popup-container ${containerClass}`} style={{ ...style }}>
				<div className="popup-header">
					<button
						className="close-notify"
						onClick={() => {
							if (typeof onClose === "function") {
								onClose();
							}
							if (isclose)
								dispatch(closeModal());
						}}
					>
						<i className="fa-solid fa-xmark"></i>
					</button>
				</div>
				<div className={classExtra ? classExtra : 'popup-body'}>
					<div style={{ width: tabed ? window.innerWidth * .8 : false, height: '100%' }}>
						{children}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Modal;